module.exports = __webpack_public_path__ + "static/img/fefco216_1.92b8c85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco216_1.png
// module id = jC4n
// module chunks = 0